<template>
  <div class="container main-container" key="index">
    <div class="row">
      <div class="col-12">
        <modal title="Confirm PredictHQ API access token" v-model="showTokenModal" :footer="!confirmingToken">
          <template v-if="!confirmingToken">
            <form @submit="onModalOkClick">
              <div>
                <field-wrapper label="Token" type="" v-model="token"
                               input-placeholder="Enter your access token"
                               :error="tokenState ?{invalidFeedback:'Please enter valid token'}:{}"/>
                <div class="text-muted">
                  Before you can access the Data Connector, you need to prove you are who you say you are. Make sure
                  you have created an API Client in <a href="https://control.predicthq.com/clients" target="_blank">
                  Control Center</a> and generated an Access Token.
                </div>
              </div>
            </form>
            <div slot="footer">
              <btn type="primary" native-type="submit" v-on:click="onModalOkClick">
                OK
              </btn>
              <btn type="default" v-on:click="onModalCancelClick">
                Cancel
              </btn>
            </div>
          </template>
          <template v-else>
            <div>
              <spinner/>
            </div>
          </template>
        </modal>
          <div class="row" v-if="!isRunningInTableau">
            <div class="col-lg-offset-3 col-lg-6">
              <div class="alert alert-danger">
                Oops. Looks like you're trying to use this Tableau Data Connector outside of Tableau, so you won't be
                able to export any events. Try our <a href="https://control.predicthq.com">Control Center</a> instead
                if you'd like to export our event data in CSV or JSON.
              </div>
            </div>
          </div>
        <div class="jumbotron">
          <h1 class="display-3">PredictHQ Tableau Data Connector</h1>

          <p class="lead">
            You don't need to be a Developer or know how to code in order to unlock and access our events.
            <a href="https://signup.predicthq.com" target="_blank">Sign up</a> for a Developer Plan if you haven't got
            an account yet. With your PredictHQ account you can take advantage of our Tableau Data Connector. This is
            particularly useful for Data Scientists and Analysts to explore our events in Tableau - a powerful BI Tool.
            Don't have Tableau? No worries, you can still download a CSV to import into another BI tool of your choice
            using our <a href="https://control.predicthq.com">Control Center</a>.
          </p>

          <hr class="my-4">
          <div class="text-center">
            <btn type="primary" v-on:click="onBeginClick" :disabled="!isRunningInTableau">
              Begin
            </btn>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import AccountAPI from '@/app/api/phq-public/account'
  import router from '@/router/'
  import fieldWrapper from '@/components/shared/field-wrapper'
  import spinner from '@/components/shared/spinner'
  import { WDCWrapper } from '@/app/wdc/wdc_wrapper'

  export default {
    components: {
      fieldWrapper,
      spinner
    },
    name: 'index',
    data () {
      return {
        isRunningInTableau: WDCWrapper.isRunningInTableau(),
        showTokenModal: false,
        checkingToken: true,
        token: '',
        confirmingToken: false,
        validToken: false,
        tokenState: null,
        accountInfo: {}
      }
    },
    methods: {
      onBeginClick () {
        this.showTokenModal = true
      },
      onModalOkClick (e) {
        e.preventDefault()
        this.confirmToken()
      },
      onModalCancelClick () {
        this.showTokenModal = false
        this.token = ''
        this.validToken = false
        this.accountInfo = {}
        Vue.config.token = ''
      },
      confirmToken () {
        this.tokenState = null
        if (!this.token) {
          this.tokenState = 'invalid'
        } else {
          this.confirmingToken = true
          AccountAPI.self({}, this.token).then(data => {
            this.validToken = true
            Vue.config.token = this.token
            router.push('/filters')
            this.confirmingToken = false
          }).catch((error) => {
            this.tokenState = 'invalid'
            this.confirmingToken = false
            Promise.reject(new Error(error))
          })
        }
      }
    }
  }
</script>
<style scoped>
</style>
